module.exports = __webpack_public_path__ + "images/FUSA_icons/099-online-shop.40c45660f898e9b1c77e8274ebd75347.svg";